module.exports = __webpack_public_path__ + "slide4-steps.8c9c6d1e4aa96d36015b797e8fbc9ff7.hashedasset.svg";